export function getGalleryMenuProps(galleryMenuData) {
    var _a, _b, _c, _d;
    const label = galleryMenuData.fields.label;
    const column1Props = {
        eyebrow: (_a = galleryMenuData.fields.column1) === null || _a === void 0 ? void 0 : _a.fields.eyebrow,
        links: (_b = galleryMenuData.fields.column1) === null || _b === void 0 ? void 0 : _b.fields.links.map(link => link === null || link === void 0 ? void 0 : link.fields),
    };
    const column2Props = {
        eyebrow: (_c = galleryMenuData.fields.column2) === null || _c === void 0 ? void 0 : _c.fields.eyebrow,
        links: (_d = galleryMenuData.fields.column2) === null || _d === void 0 ? void 0 : _d.fields.links.map(link => link === null || link === void 0 ? void 0 : link.fields),
    };
    return { label, column1Props, column2Props };
}
//# sourceMappingURL=getGalleryMenuProps.js.map